import React from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import { hideDeposit$, toggleHideDeposit } from './h&s';
import { trackEvent } from '../../analytics/gtm';
import { Switch } from '../forms/Switch';

export const HideAccountSumSwitch = () => {
    const { subscribe } = useReframe();
    const value = subscribe(hideDeposit$);
    const toggle = () => {
        trackEvent('Osobna zona', value ? 'Skryt stav konta' : 'Zobrazit stav konta');
        dispatch(toggleHideDeposit);
    };
    return <Switch active={value} onClick={toggle} dataAtid="toggle-switch-hide-cash" />;
};
